const integerFormatter = new Intl.NumberFormat("en-US", { maximumFractionDigits: 0 });
const compactFormatter = new Intl.NumberFormat("en-US", {
  notation: "compact",
  maximumFractionDigits: 1,
});

export function formatDecimal(value: string): string {
  const asBigInt = BigInt(value);
  if (asBigInt <= BigInt(Number.MAX_SAFE_INTEGER)) {
    return integerFormatter.format(Number(asBigInt));
  }
  const sign = value.startsWith("-") ? "−" : "";
  const digits = value.replace(/^-/, "");
  return `${sign}${digits.slice(0, 4)}…${digits.slice(-4)}`;
}

export function formatCompact(value: number): string {
  return compactFormatter.format(value).replace("K", "k").replace("B", "B");
}

export function formatUtcTime(timestamp: number): string {
  return new Intl.DateTimeFormat("en-GB", {
    timeZone: "UTC",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: false,
  }).format(new Date(timestamp));
}

export function operationSymbol(operation: "add" | "subtract"): "+" | "−" {
  return operation === "add" ? "+" : "−";
}

